import {useFormContext} from "react-hook-form";

import {DatePickerField} from "@/components/form/fields/DatePickerField.tsx";
import {NumberInputField} from "@/components/form/fields/NumberInputField.tsx";
import {RadioField} from "@/components/form/fields/RadioField/RadioField.tsx";
import {EndType} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";

import styles from "./EndSection.module.scss";

export const EndSection = () => {
  const {watch, clearErrors} = useFormContext();
  const endType: EndType = watch("end_type") ?? EndType.NEVER;

  const handleEndTypeChange = () => {
    clearErrors(["rrule_count", "rrule_until"]);
  };

  return (
    <div className={"d-flex flex-column gap-2"}>
      <span className="pulseTextBodySmallBold">Ends</span>
      <div className={"d-flex flex-column gap-3"}>
        <RadioField
          name="end_type"
          value={EndType.NEVER}
          label="Never"
          variant="input"
          onChange={handleEndTypeChange}
        />

        <div>
          <div className={"d-flex align-items-center gap-2"}>
            <RadioField
              name="end_type"
              value={EndType.ON}
              label="On"
              variant="input"
              className={styles.endRadio}
              onChange={handleEndTypeChange}
            />
            <DatePickerField
              name="rrule_until"
              mode="single"
              disabled={endType !== EndType.ON}
              datePickerV3Props={{hasTimeSelect: false, disablePastDates: true}}
              className={styles.endInput}
            />
          </div>
        </div>

        <div>
          <div className={"d-flex align-items-center gap-2"}>
            <RadioField
              name="end_type"
              value={EndType.AFTER}
              label="After"
              variant="input"
              className={styles.endRadio}
              onChange={handleEndTypeChange}
            />
            <NumberInputField
              name="rrule_count"
              label=""
              disabled={endType !== EndType.AFTER}
              className={styles.endInput}
              placeholder="Occurrences"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
